import BaseModel from '@/orm/models/BaseModel';
import api from '@/api';

export default class PaymentMethod extends BaseModel {
  static primaryKey = 'id';

  static entity = 'paymentMethods';

  static fields() {
    return {
      id: this.number(null),
      data: this.attr(null),
      type: this.string(null),
      active: this.boolean(null),
      title: this.string(null),
      fullTitle: this.string(null),
      failedAt: this.string(null).nullable(),
      paymentSystem: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      fetchCurrent() {
        return this.get('billing/methods/current');
      },
      fetch() {
        return this.get('billing/methods');
      },
      destroy(id) {
        return this.delete(`billing/methods/${id}`, { delete: true });
      },
      active(id) {
        return this.put(`billing/methods/${id}/active`);
      },
      updateData({ id, data }) {
        return this.put(`billing/methods/${id}/data`, { data }, {
          dataTransformer(methodData) {
            return methodData.data;
          },
        });
      },
      store({ id, driver }) {
        return this.post(`/billing/payment/${driver}/method/store`, {
          id,
        });
      },
    },
  }
}
